
export function getAppointmentMenuItem({
    disableMyChartMenuItems,
    isMyChartUser,
}) {

    return {
        show: isMyChartUser,
        disabled: disableMyChartMenuItems,
        navHead: {
            label: 'Appointments',
            url: null,
            icon: 'calendar'
        },
        navItems: [
            {
                label: 'Visits & After Visit Summaries',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/appointments',
                subMenuItems: null
            },
            {
                label: 'Scheduling Preferences',
                show: isMyChartUser,
                disabled: disableMyChartMenuItems,
                url: '/preferences',
                subMenuItems: null,
            },
        ],
    }
}